export const AVATARS_FOLDER_URL = 'https://s3.amazonaws.com/images.growmindgrow/avatars/';

export const PARENT_SITE_CHILDREN_URL = `${process.env.VUE_APP_PARENT_SITE}/parent/account/children`;
